<template>
  <div class="row-onlinebook row-myattention">
    <LeftListSupplier v-if="isSupplier" :pos="8"></LeftListSupplier>
    <LeftListMember v-else :pos="8"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1 m-myattention">
        <ul class="g-tablist1" style="top: 0;">
          <li class="li ">
            <router-link to="/common-myattention" class="txt">我的关注</router-link>
          </li>
          <li class="li on">
            <router-link to="/common-myfans" class="txt">我的粉丝</router-link>
          </li>
        </ul>
        <div class='titattention1'>共{{ dataCount }}个关注</div>
        <div class="contect">
          <ul class="ul-myattention ul-fans">
            <li class="li" v-for="item in data" :key="item.id">
              <div class="con">
                <div class="con1">
                  <div class="pic" v-if="item.userInfo.avatar"><img :src="item.userInfo.avatar" alt="" /></div>
                  <div class="pic" v-else><img src="@/assets/images/nopic.jpg" alt="" /></div>
                  <div class="txt">
                    <div class="tit">{{ item.userInfo.realname }} </div>
                    <div class="id">ID ：{{ item.userInfo.showId }}<img @click="copyText(item.userInfo.showId)" class="copy" src="@/assets/images/e-copy.png" alt="" /></div>
                    <div class="info"><span>单位名称 </span> {{ item.userInfo.companyName }}</div>
                    <div class="m-btn">
                      <div class="btn" v-if="item.isBothSubscribe" @click="changeSubscribe(item.userInfo.uid)">相互关注</div>
                      <div class="btn on" v-else @click="changeSubscribe(item.userInfo.uid)">关注</div>
                      <a class="btn" :href="'/home/user_info/home?id='+item.userInfo.showId">主页</a>
                    </div>
                  </div>
                </div>
                <div class="con2">
                  <div class="txt2">
                    <div class="tit2">联系信息：</div>
                    <div class="info1">
                      <p><img src="@/assets/images/e-icon1.png" alt=""
                              class="icon"><span>地址：{{ item.userInfo.address }}</span></p>
                      <p><img src="@/assets/images/e-icon2.png" alt="" class="icon"><span>电话：{{ item.userInfo.mobile }}</span></p>
                      <p><img src="@/assets/images/e-icon3.png" alt="" class="icon"><span>邮箱：{{ item.userInfo.email }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="pic2" @click="showModal(item.company.businessCardImg)">
                    <img v-if="item.company.businessCardImg" :src="item.company.businessCardImg" alt="" />
                    <img v-else src="@/assets/images/nopic.jpg" alt="" />
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <mPages :page.sync="filter.page" :page-size.sync="filter.pageSize" :total="dataCount" />
        </div>
      </div>
    </div>
  <!-- 弹窗 -->
  <a-modal :visible="visible" @ok="handleOk" class="m-pope1 m-picpope1" @cancel="handleCancel" :footer="null" :centered="true"
      :closable="false" :width="895">
      <div class="inner">
        <div class="pic2"><img :src="bigImg" alt="" /></div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import mPages from '@/components/mpages/mPages.vue'
import LeftListMember from "@/components/LeftListMember.vue";
import LeftListSupplier from "@/components/LeftListSupplier.vue";
import {getApiRes} from "@/api/apiUtil";
import apiUserInfo from "@/api/userInfo";
import apiUserFollow from "@/api/userFollow";
export default {
  components: {
    LeftListMember,
    LeftListSupplier,
    mPages,
  },
  data() {
    return { ModalText: "Content of the modal",
      visible: false,
      bigImg: '',
      confirmLoading: false,
      filter: {
        page: 1,
        pageSize: 10,
      },
      dataCount: 0,
      data: [],
    };
  },
  computed: {
    isSupplier(){
      return this.$store.state.user.roles.indexOf('supplier') > -1
    }
  },
  watch: {
    filter: {
      handler() {
        this.load()
      },
      deep: true
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load(page = undefined){
      if(page) this.filter.page = page
      let  re = await getApiRes(apiUserInfo.GetFansList(this.filter.page, this.filter.pageSize))
      if(re.code == 0){
        this.data = re.data
        this.dataCount = re.count
      }
    },
    async changeSubscribe(uid){
      let re = await getApiRes(apiUserFollow.subscribe(uid),0,1,1,1)
      if(re.code==0){
        let item = this.data.find(v => v.userInfo.uid == uid)
        item.isBothSubscribe = re.data == 1
      }
    },
    showModal(img) {
      this.bigImg = img
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
    },
    async copyText(text) {
      try {
        // const text = 'ID ：77885214065';
        await navigator.clipboard.writeText(text);
        console.log('文字复制成功');
        this.$message.success('复制成功');
      } catch (error) {
        console.error('文字复制失败', error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.m-myattention .g-pages{
margin:40px 60px 0 50px;
}
</style>
